var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgXls = function SvgXls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 4v5.333A1.333 1.333 0 0020 10.667h5.333M18.667 4H9.333a2.667 2.667 0 00-2.666 2.667V16m12-12l6.666 6.667m0 0V16m-20 4l5.334 8m-5.334 0l5.334-8m12 7a1 1 0 001 1h1.666a1.334 1.334 0 001.334-1.333v-1.334A1.334 1.334 0 0025.333 24H24a1.334 1.334 0 01-1.333-1.333v-1.334A1.334 1.334 0 0124 20h1.667a1 1 0 011 1m-12-1v8h4",
    stroke: "#089BEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgXls;